/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-loop-func */
/**
 * #######################################################@
 *
 * Page settings
 *
 * #######################################################@
 */
import "./style.css";

import {
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	FormControl,
	Icon,
	IconButton,
	InputLabel,
	MenuItem,
	Select
} from "@mui/material";
import { useEffect, useState } from "react";
import MDButton from "components/Basics/MDButton";
import MDBox from "components/Basics/MDBox";
import MDInput from "components/Basics/MDInput";
import MDTypography from "components/Basics/MDTypography";
import ConfirmDialogButton from "components/Custom/Dialogs/ConfirmDialogButton";
import { useDispatch, useSelector } from "react-redux";
import SettingsActions from "redux-react/actions/settingsActions";
import ProfileActions from "redux-react/actions/profileActions";
import lod_ from "lodash";
import { updatePermissions } from "redux-react/reducers/permissionsReducer";
import DictionaryMenu from "../filters/DictionaryMenu";
import IconAccordion from "../charts/steps/components/IconAccordion";
import FiltersDndList from "./components/FiltersDndList";
import { t } from "i18next";
import { display } from "redux-react/reducers/snackBarReducer";

/**
 * Component to display a role in the list
 */
const RolesBox = ({ type, name, code, rolesList = [], onChange }) => {
	const isInArray = arr => {
		return arr.includes(code);
	};

	return (
		<MenuItem onClick={() => onChange(code)}>
			<MDBox display="flex" alignItems="center" justifyContent="start">
				<Checkbox checked={isInArray(rolesList)} />
				<MDBox display="flex" flexDirection="column">
					<MDTypography variant="body">{name}</MDTypography>
				</MDBox>
			</MDBox>
		</MenuItem>
	);
};

export default function AddPageDialog({
	open,
	handleCloseDialog,
	rank,
	dictionary: clientDictionary,
	page = null
}) {
	const profile = useSelector(state => state.profile);
	const dispatch = useDispatch();
	/* Page attributes */
	const [name, setName] = useState(null);
	const [type, setType] = useState("route");
	const [icon, setIcon] = useState(null);
	const [filters, setFilters] = useState([]);

	const [addFilterAnchorEl, setAddFilterAnchorEl] = useState(null);

	/**
	 * Create list filters merging "special" and "dictionary" filters
	 */
	const SPECIAL_FILTERS = {
		basicFieldsTitle: {
			source: "title",
			label: t("FILTERS.basicFieldsTitle")
		},
		specialDate: {
			source: "special",
			code: "date",
			label: {
				fr: t("FILTERS.specialDate")
			},
			type: "datetime"
		},
		dictionaryFieldsTitle: {
			source: "title",
			label: t("FILTERS.dictionaryFieldsTitle")
		}
	};

	const dictionary = {
		...SPECIAL_FILTERS,
		...clientDictionary
	};

	const [filterByAgentAdd, setFilterByAgent] = useState(null);
	// -> Roles that will be displayed in the list to be selected
	const [defaultRolesList, setDefaultRolesList] = useState([]);
	// -> Roles that will be selected by the user
	const [rolesList, setRolesList] = useState(["supervisor", "soloUser"]);

	const [iconsList, setIconsList] = useState([]);

	/**
	 * Check if the page is disabled
	 * @param {string} type - type of the page
	 * @returns {boolean} - true if the page is disabled
	 */
	const disabledForType = type => {
		switch (type) {
			case "route":
				if (!name) {
					return true;
				}
				break;
			case "title":
				if (!name) {
					return true;
				}
				break;
			case "divider":
				return false;
			default:
				return false;
		}

		return false;
	};

	const isDisabled = disabledForType(type);

	/**
	 * Close dialog
	 */
	function close() {
		handleCloseDialog();
	}

	/**
	 * Create the page permission
	 * format be like : "read:page_[type]_[name]"
	 * For dividers, need to create a random ID because they have no name
	 */
	function createPagePermission(type, routeName, list) {
		// If user didn't select any role, return null -> We dont want permission on this page
		if (!list || lod_.isEmpty(list)) return null;
		// If the page is a divider, create a random ID for it
		if (type === "divider") {
			let rdmID = Math.random().toString(36).substring(7);
			return `read:page_${type}_${rdmID}`;
		}
		// Else, return the permission
		return `read:page_${type}_${routeName}`;
	}

	/**
	 * Save new page object
	 * - it can be created or updated
	 * @param {object} newPage - new page object
	 */
	function saveNewPage(newPage) {
		if (lod_.isNil(page)) {
			// Create the page
			const onSuccess = res => {
				dispatch(
					display({
						message: t("SETTINGS.PAGES.SUCCESS.add"),
						type: "success"
					})
				);
				handleCloseDialog(true);
				dispatch(ProfileActions.updateMenu(profile.assistantID));
			};
			dispatch(SettingsActions.newSetting(profile.assistantID, "page", newPage, onSuccess));
		} else {
			// Update the page
			const onSuccess = res => {
				dispatch(
					display({
						message: t("SETTINGS.PAGES.SUCCESS.edit"),
						type: "success"
					})
				);
				handleCloseDialog(true);
				dispatch(ProfileActions.updateMenu(profile.assistantID));
			};

			dispatch(
				SettingsActions.editSetting(
					profile.assistantID,
					"page",
					{
						_id: page._id,
						...newPage,
						rank: page.rank // Keep the same rank
					},
					onSuccess
				)
			);
		}
	}

	/**
	 * Submit the dialog, create the page
	 */
	function sumbit() {
		// 1- Create the page permission
		let pagePermission = createPagePermission(
			type,
			name?.toLowerCase().trim().replaceAll(" ", "-"),
			rolesList
		);

		let newPage = {
			// For all pages types
			rank,
			type,
			permissions: pagePermission ? [pagePermission] : []
		};

		// 2- Map datas to the object
		switch (type) {
			// When we create a "route" => A page
			case "route": {
				newPage.name = name;
				newPage.route = `/${name.toLowerCase().trim().replaceAll(" ", "-")}`;
				newPage.icon = icon;
				newPage.filterByAgent = filterByAgentAdd;
				newPage.filters = filters;
				break;
			}
			// When we create a title
			case "title": {
				newPage.name = name;
				break;
			}
			default:
				break;
		}

		// 3- If the user set some permissions, need to save them
		if (!lod_.isEmpty(rolesList)) {
			// 3.1- First, create the custom permissions for the page
			// 3.2- Then, get the new permissions list and update the profile

			/* Handler when getting new permissions */
			const getCustomPermissionsSuccess = res => {
				// Update store with the new permissions
				dispatch(updatePermissions(res.permissions));
				saveNewPage(newPage);
			};
			/* Handler when saving permissions */
			const createCustomPermissionSuccess = res => {
				// Get the new permissions list
				dispatch(
					ProfileActions.getCustomPermissions(
						profile.assistantID,
						profile.role,
						getCustomPermissionsSuccess
					)
				);
			};
			// Save the custom permissions for the page, for all the selected roles
			dispatch(
				ProfileActions.createCustomPermission(
					profile.assistantID,
					rolesList,
					process.env.REACT_APP_APPNAME,
					pagePermission,
					createCustomPermissionSuccess
				)
			);
		} else {
			saveNewPage(newPage);
		}
	}

	/**
	 * When user select / deselect a role in the list
	 */
	function updateRolesList(newRole) {
		if (rolesList.includes(newRole)) {
			setRolesList(rolesList.filter(role => role !== newRole));
		} else {
			setRolesList([...rolesList, newRole]);
		}
	}
	/**
	 * Load default roles list (from KM)
	 */
	function loadRoles() {
		dispatch(
			SettingsActions.getRoles(res => {
				// Sort by type
				res.roles.sort((a, b) => {
					if (a.type < b.type) return -1;
					if (a.type > b.type) return 1;
					return 0;
				});
				setDefaultRolesList(res.roles);
			})
		);
	}

	/**
	 * Add a new filter to the list
	 * @param {string} fullDictionaryPath - The path of the filter in the dictionary
	 * @returns {void}
	 */
	const addNewFilter = fullDictionaryPath => {
		let dictionaryCode = fullDictionaryPath.split(".")[0];

		const dictionaryOfElement = lod_.get(dictionary, dictionaryCode);
		const source = dictionaryOfElement?.source;

		let path = lod_.cloneDeep(fullDictionaryPath);
		if (path.split(".").length > 1) {
			path = path.split(".").slice(1).join(".");
		}

		// Try to get the item in the dictionary
		const dictionaryItem = lod_.get(
			dictionaryOfElement?.items || {},
			path.replaceAll(".", ".items."),
			{}
		);

		if (lod_.isEmpty(dictionaryItem) && source !== "special") {
			return;
		}

		setAddFilterAnchorEl(null);
		let same = filters.find(f => f.path === path);
		if (!same) {
			let filter = {
				dictionary: dictionaryCode,
				path,
				source: source === "special" ? source : "dictionary"
			};

			if (source === "special") {
				filter.type = dictionaryOfElement.type;
			}

			setFilters(prev => [...filters, filter]);
		}
	};

	/**
	 * When editing a filter
	 * @param {number} index - The index of the filter in the list
	 * @param {object} edit - The editions to apply
	 */
	const onEdit = (index, edit) => {
		let clonedFilters = lod_.cloneDeep(filters);
		let item = clonedFilters[index];
		item = lod_.merge(item, edit);
		clonedFilters[index] = item;
		setFilters(clonedFilters);
	};

	/**
	 * Remove a link from a filter
	 * @param {number} itemItem - The index of the filter in the list
	 * @param {number} linkIndex - The index of the link in the filter
	 */
	const removeLink = (itemItem, linkIndex) => {
		let clonedFilters = lod_.cloneDeep(filters);
		let item = clonedFilters[itemItem];
		item.links.splice(linkIndex, 1);
		clonedFilters[itemItem] = item;
		setFilters(clonedFilters);
	};

	/**
	 * Add a link to a filter
	 * @param {object} item - The filter to link
	 * @param {number} index - The index of the filter in the list
	 * @param {string} fullDictionaryPath - The path of the filter in the dictionary
	 */
	const linkItem = (item, index, fullDictionaryPath) => {
		let dictionaryCode = fullDictionaryPath.split(".")[0];

		const dictionaryItem = lod_.get(dictionary, dictionaryCode);
		const source = dictionaryItem?.source;

		let path = lod_.cloneDeep(fullDictionaryPath);
		if (path.split(".").length > 1) {
			path = path.split(".").slice(1).join(".");
		}

		setAddFilterAnchorEl(null);

		let link = {
			dictionary: dictionaryCode,
			path,
			source: source === "special" ? source : "dictionary"
		};

		item.links = item.links || [];

		let same = item.links.find(l => `${l.dictionaryCode}.${l.path}` === fullDictionaryPath);
		if (!same) {
			item.links.push(link);
		}

		let clonedFilters = lod_.cloneDeep(filters);
		clonedFilters[index] = item;
		setFilters(clonedFilters);
	};

	/**
	 * Get the permissions of the page (if exists)
	 * and load all the roles that have this permission
	 */
	function loadRolesByPagePermission(page) {
		if (!page) return;

		let pagePermissions = page.permissions || [];

		let promises = [];
		let tempRolesList = [];

		for (let perm of pagePermissions) {
			promises.push(
				new Promise((resolve, reject) => {
					dispatch(
						ProfileActions.getRolesByPagePermission(profile.assistantID, perm, res => {
							let roles = res.roles.map(role => role.role);
							tempRolesList = [...tempRolesList, ...roles];
							resolve();
						})
					);
				})
			);
		}

		Promise.all(promises).then(() => {
			setRolesList(tempRolesList);
		});
	}

	useEffect(() => {
		const onSuccess = res => {
			setIconsList(res.icons);
			// setDefaultIconsListn(res.icons);
		};
		dispatch(SettingsActions.getIcons(profile.assistantID, onSuccess));
	}, []);

	/**
	 * Load roles list on start
	 */
	useEffect(() => {
		if (open === true) {
			loadRoles();
			if (page !== null) {
				setName(prev => page.name);
				setIcon(page.icon);
				setFilterByAgent(page?.filterByAgent || false);
				setFilters(page?.filters || []);
				loadRolesByPagePermission(page);
			}
		} else {
			// Reset default values when closing the dialog
			setName(prev => null);
			setType("route");
			setFilterByAgent(null);
			setRolesList(["supervisor", "soloUser"]);
		}
	}, [open]);

	return (
		<Dialog
			fullWidth
			maxWidth="xxl"
			open={open}
			PaperProps={{
				style: {
					height: "100%"
				}
			}}
		>
			<MDBox
				display="flex"
				flex="1"
				style={{
					overflowY: "auto"
				}}
			>
				{/* Informations */}
				<MDBox flex="4" display="flex" flexDirection="column">
					<DialogTitle>{t("SETTINGS.PAGES.pageDialogTitle")}</DialogTitle>
					<DialogContent
						style={{
							flex: 1
						}}
					>
						<MDBox mt={1}>
							<FormControl fullWidth>
								<InputLabel
									style={{
										padding: "12px !important"
									}}
									id="select-type"
								>
									{t("SETTINGS.PAGES.type")}
								</InputLabel>
								<Select
									disabled={page !== null}
									labelId="select-type"
									value={type}
									label={t("SETTINGS.PAGES.type")}
									onChange={e => setType(e.target.value)}
								>
									<MenuItem value="route">{t("SETTINGS.PAGES.route")}</MenuItem>
									<MenuItem value="title">{t("SETTINGS.PAGES.title")}</MenuItem>
									<MenuItem value="divider">{t("SETTINGS.PAGES.divider")}</MenuItem>
								</Select>
							</FormControl>
						</MDBox>

						{type !== "divider" && (
							<MDBox mt={1}>
								<MDInput
									className="dialogInput"
									label={t("SETTINGS.PAGES.name")}
									value={name}
									onChange={e => setName(prev => e.target.value)}
								/>
							</MDBox>
						)}
						{(type === "route" || type === "form") && (
							<MDBox display="flex" alignItems="flex-start " flexDirection="column">
								<MDBox mt={1}>
									{/* Icon choice */}
									<IconAccordion
										open
										forceOpen
										title={t("SETTINGS.CHARTS.NEW.iconAvailableIcons")}
										content={iconsList.map((ic, index) => {
											return (
												<IconButton
													key={index}
													onClick={() => {
														setIcon(ic.code);
													}}
												>
													<Icon color={icon === ic.code ? "info" : ""} fontSize="large">
														{ic.code}
													</Icon>
												</IconButton>
											);
										})}
										actions={
											<MDButton onClick={() => setIcon(null)}>
												<Icon>close</Icon>&nbsp;{t("SETTINGS.delete")}
											</MDButton>
										}
									/>
								</MDBox>
							</MDBox>
						)}
					</DialogContent>
				</MDBox>
				{/* Filters */}
				<MDBox
					flex="3"
					style={{
						borderLeft: "1px solid rgba(224, 224, 224, 0.77)",
						overflowY: "auto",
						display: "flex",
						flexDirection: "column"
					}}
				>
					<DialogTitle>
						<MDBox display="flex" justifyContent="space-between" alignItems="center">
							<MDTypography variant="h5">{t("SETTINGS.PAGES.addFilters")}</MDTypography>
							<MDButton
								variant="contained"
								color="info"
								size="small"
								onClick={e => setAddFilterAnchorEl(e.target)}
							>
								<Icon>add</Icon>&nbsp;Ajouter
							</MDButton>
							<DictionaryMenu
								dictionary={dictionary}
								anchorEl={addFilterAnchorEl}
								handleInsertText={addNewFilter}
								handleClose={() => setAddFilterAnchorEl(null)}
								clickableLevels={false}
							/>
						</MDBox>
					</DialogTitle>
					<DialogContent
						style={{
							overflowY: "auto",
							display: "flex",
							flexDirection: "column"
						}}
					>
						{/* Agent filter */}
						<MenuItem onClick={() => setFilterByAgent(!filterByAgentAdd)}>
							<MDBox display="flex" alignItems="center" justifyContent="start">
								<Checkbox checked={filterByAgentAdd ?? false} />
								<MDBox display="flex" flexDirection="column">
									<MDTypography variant="h6">{t("SETTINGS.PAGES.filterByAgent")}</MDTypography>
									<MDTypography
										variant="caption"
										style={{
											whiteSpace: "pre-line"
										}}
									>
										{t("SETTINGS.PAGES.filterAgentDescription")}
									</MDTypography>
								</MDBox>
							</MDBox>
						</MenuItem>
						{/*  */}
						<Divider />
						{/*  */}
						<FiltersDndList
							dictionary={dictionary}
							items={filters}
							onChange={newList => {
								setFilters(prev => newList);
							}}
							deleteItem={index => {
								setFilters(prev => {
									let newList = [...prev];
									newList.splice(index, 1);
									return newList;
								});
							}}
							linkItem={linkItem}
							removeLink={removeLink}
							onEdit={onEdit}
						/>
					</DialogContent>
				</MDBox>
				{/* Visibility */}
				<MDBox
					flex="2"
					style={{
						borderLeft: "1px solid rgba(224, 224, 224, 0.77)"
					}}
				>
					<DialogTitle>{t("SETTINGS.PAGES.visibleBy")}</DialogTitle>
					<DialogContent>
						{defaultRolesList &&
							defaultRolesList.map((perm, index) => {
								return (
									<RolesBox
										key={index}
										type={perm.type}
										name={perm.name}
										code={perm.code}
										rolesList={rolesList}
										onChange={perm => {
											updateRolesList(perm);
										}}
									/>
								);
							})}
					</DialogContent>
				</MDBox>
			</MDBox>
			{/* Actions */}
			<DialogActions>
				<MDButton variant="outlined" color="info" onClick={close}>
					{t("SETTINGS.cancel")}
				</MDButton>
				{rolesList.includes("agent") || lod_.isEmpty(rolesList) ? (
					<ConfirmDialogButton
						onConfirm={(e, values) => {
							sumbit();
						}}
						component={
							<MDButton disabled={isDisabled} variant="contained" color="info" onClick={sumbit}>
								{t("SETTINGS.save")}
							</MDButton>
						}
						title={t("SETTINGS.PAGES.selectAgentRoleTitle")}
						content={t("SETTINGS.PAGES.selectAgentRoleDescription")}
					/>
				) : (
					<MDButton disabled={isDisabled} variant="contained" color="info" onClick={sumbit}>
						{t("SETTINGS.save")}
					</MDButton>
				)}
			</DialogActions>
		</Dialog>
	);
}
